export default {
    setPaymentMethodId: (state, paymentMethodId) => state.paymentMethodId = paymentMethodId,
}
